export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11618.d9e70df1.jpg";